'use client';
import React, { useContext } from 'react';
import { Button } from '../components';
import { SpinnerBox } from './spinner-box';
import { useQueryPriceContract } from '@/hooks/orderhistory.hook';
import clsx from 'clsx';
import LanguageContext from '@/context/language';
import { usePrintContract } from '@/hooks/pdf.hook';

interface IProps {
  orderNumber: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

export const PrintContractButton = ({ orderNumber, children, className, disabled }: IProps) => {
  const { lang } = useContext(LanguageContext);
  const { data } = useQueryPriceContract(orderNumber);
  const { mutateAsync, isLoading } = usePrintContract();

  const onExport = async () => {
    if (!data) return;
    const pdfUrl = await mutateAsync({ ...data, lang });
    window.open(pdfUrl, '_blank');
  };

  if (!data) {
    return null;
  }

  return (
    <SpinnerBox isLoading={isLoading}>
      <div className="flex w-full">
        <Button type="outline" className={clsx(className, 'flex-1')} onClick={onExport} disabled={disabled || !data}>
          {children}
        </Button>
      </div>
    </SpinnerBox>
  );
};
